import { Grid, Paper, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { Button, Input } from "../../controls";
import { useTranslation } from "react-i18next";
import { Form } from "../../layout";
import { action, controller, Server } from "../../api/Server";
import { formatDate, ToFormData } from "../../hooks/Method";
import { toast } from "react-toastify";

const CashInDrawer = ({ setShow }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setCLoader, selStore, setLoader, loader } = useContext(AppContext);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const amountRef = useRef();

  const handleFocus = () => {
    if (amountRef.current) {
      amountRef.current.select();
      amountRef.current.focus();
    }
  };

  useEffect(() => {
    handleFocus();

    return () => {};
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value !== "") {
      setLoader(true);

      const onComplete = (res) => {
        if (res?.status === 200 && res.result?.id) {
          setLoader(false);
          setShow(false);
          toast.success("Register is now open and ready for transactions.");
        } else {
          toast.error(
            res?.msg ||
              "Opps, something is wrong. Please refresh the page and try again."
          );
        }
      };

      Server(controller.Register + action.OpenReg).post(
        ToFormData({
          openingBalance: value,
          storeId: selStore,
          openTime: new Date().toISOString(),
        }),
        onComplete
      );
    } else {
      setError(t("amountIsRequired"));
      handleFocus();
    }
  };

  const handleLogout = () => {
    setCLoader(true);
    const onComplete = (res) => {
      setCLoader(false);
      navigate("/");
    };
    Server(controller.Auth + action.Logout).get(onComplete);
  };

  return (
    <Paper className="p-10 bg-white border-none">
      <Form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} className="tx-center mt-20">
            <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
              {t("openRegister")}
            </Typography>
            <div className="bs-bottom mx-w-80 m-auto mt-5 mb-10" />
          </Grid>
          <Grid item xs={12}>
            <span className="fs-18 fw-5 gray-color tx-upp ml-5 fs-italic ">
              {t("openTime")}: {formatDate(new Date())}
            </span>
          </Grid>
          <Grid item xs={12}>
            <Input
              onChange={(e) => setValue(e.target.value)}
              label={t("openingBalance")}
              placeholder="0.000"
              name="amount"
              type="number"
              error={error}
              inputRef={amountRef}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} className="d-flex g-10">
            <Button
              onClick={handleLogout}
              className="error-color bg-errorSM w-100pr"
              size="large"
            >
              {t("logout")}
            </Button>
            <Button
              onClick={() => navigate("/")}
              className="w-100pr"
              size="large"
              variant="text"
            >
              {t("home")}
            </Button>
            <Button
              type="submit"
              onClick={handleSubmit}
              className="w-100pr"
              variant="contained"
              size="large"
              loading={loader}
            >
              {t("open")}
            </Button>
          </Grid>
        </Grid>
      </Form>
    </Paper>
  );
};

export default CashInDrawer;
